export default __webpack_public_path__ + "8df3003d8fe6dd8b186ace1cd49db406.svg";